<!-- One header row, as in the desktop app: brand · section tabs · desktop app · settings · account -->
<header class="top">
  <a class="brand" [routerLink]="['/admin', menu.dashboard.state]" aria-label="Optimus — Dashboard">
    <svg class="logo" viewBox="0 0 64 64" aria-hidden="true"><circle cx="32" cy="32" r="18" fill="none" stroke="#fff" stroke-width="9"/></svg>
    <span class="brand-text"><strong>Optimus</strong><span class="sub">Console</span></span>
  </a>

  <nav class="tabs" aria-label="Sections">
    <a class="tab" [routerLink]="['/admin', menu.dashboard.state]" routerLinkActive="active">
      <mat-icon>{{ menu.dashboard.icon }}</mat-icon>{{ menu.dashboard.name }}</a>
    <button type="button" class="tab" [class.active]="inAuthoring()" [matMenuTriggerFor]="authoring">
      <mat-icon>edit_note</mat-icon>Authoring<mat-icon class="caret">expand_more</mat-icon></button>
    <ng-container *ngFor="let item of menu.operations">
      <a *ngIf="!item.adminOnly || (isAdmin$ | async)" class="tab" [routerLink]="['/admin', item.state]" routerLinkActive="active">
        <mat-icon>{{ item.icon }}</mat-icon>{{ item.name }}</a>
    </ng-container>
  </nav>
  <mat-menu #authoring="matMenu">
    <a mat-menu-item *ngFor="let item of menu.authoring" [routerLink]="['/admin', item.state]" routerLinkActive="active">
      <mat-icon>{{ item.icon }}</mat-icon>{{ item.name }}<span class="new" *ngIf="item.isNew">New</span></a>
  </mat-menu>

  <div class="top-right">
    <a class="desktop-link" [href]="desktopDownload" title="Optimus Desktop for Mac with Apple silicon: build tests with a browser beside you">
      <mat-icon>download</mat-icon><span>Desktop app</span></a>
    <a class="icon-btn" [routerLink]="['/admin', menu.settings.state]" routerLinkActive="active" [title]="menu.settings.name">
      <mat-icon>{{ menu.settings.icon }}</mat-icon></a>
    <app-header></app-header>
  </div>
</header>

<main class="page">
  <router-outlet></router-outlet>
</main>
